export interface NavCategory {
  /** i18n key (in `common` namespace) for the category title. */
  titleKey: string;
  /** @deprecated Use `titleKey` with i18n. Kept for backward compatibility. */
  title: string;
  /** @deprecated Use `titleKey` with i18n. Kept for backward compatibility. */
  titleEn: string;
  items: {
    /** i18n key (in `common` namespace) for the item label. */
    labelKey: string;
    /** @deprecated Use `labelKey` with i18n. Kept for backward compatibility. */
    name: string;
    /** @deprecated Use `labelKey` with i18n. Kept for backward compatibility. */
    nameEn: string;
    /** BG slug-prefixed href. Used as the route key; not user-visible text. */
    href: string;
    badge?: string;
  }[];
}

export interface NavLink {
  /** i18n key (in `common` namespace) for the link label. */
  labelKey: string;
  /** @deprecated Use `labelKey` with i18n. Kept for backward compatibility. */
  name: string;
  /** @deprecated Use `labelKey` with i18n. Kept for backward compatibility. */
  nameEn: string;
  /** BG slug-prefixed href. The header layers the language prefix on top. */
  href: string;
  /** Mega-menu sections that drop down from this link. */
  megaMenu?: NavCategory[];
  badge?: string;
}

export const MEGA_MENU_CATEGORIES: NavCategory[] = [
  {
    titleKey: 'categories.photoGifts.title',
    title: 'Фото Подаръци', // i18n-ignore: see titleKey
    titleEn: 'Photo Gifts',
    items: [
      {
        labelKey: 'categories.photoGifts.photoCrystals',
        name: 'Фото Кристали', // i18n-ignore: see labelKey
        nameEn: 'Photo Crystals',
        href: '/продукти?category=photo-crystals', // i18n-ignore: route slug
      },
      {
        labelKey: 'categories.photoGifts.photoFrames',
        name: 'Фото Рамки', // i18n-ignore: see labelKey
        nameEn: 'Photo Frames',
        href: '/продукти?category=photo-frames', // i18n-ignore: route slug
      },
      {
        labelKey: 'categories.photoGifts.photoStones',
        name: 'Фото Камъни', // i18n-ignore: see labelKey
        nameEn: 'Photo Stones',
        href: '/продукти?category=photo-stones', // i18n-ignore: route slug
      },
      {
        labelKey: 'categories.photoGifts.clocks',
        name: 'Часовници', // i18n-ignore: see labelKey
        nameEn: 'Clocks',
        href: '/продукти?category=clocks', // i18n-ignore: route slug
      },
    ],
  },
  {
    titleKey: 'categories.customization.title',
    title: 'Персонализация', // i18n-ignore: see titleKey
    titleEn: 'Customization',
    items: [
      {
        labelKey: 'categories.customization.mugs',
        name: 'Чаши', // i18n-ignore: see labelKey
        nameEn: 'Mugs',
        href: '/продукти?category=mugs', // i18n-ignore: route slug
      },
      {
        labelKey: 'categories.customization.pillows',
        name: 'Възглавници', // i18n-ignore: see labelKey
        nameEn: 'Pillows',
        href: '/продукти?category=pillows', // i18n-ignore: route slug
      },
      {
        labelKey: 'categories.customization.puzzles',
        name: 'Пъзели', // i18n-ignore: see labelKey
        nameEn: 'Puzzles',
        href: '/продукти?category=puzzles', // i18n-ignore: route slug
      },
      {
        labelKey: 'categories.customization.tshirts',
        name: 'Тениски', // i18n-ignore: see labelKey
        nameEn: 'T-shirts',
        href: '/продукти?category=tshirts', // i18n-ignore: route slug
      },
    ],
  },
  {
    titleKey: 'categories.accessories.title',
    title: 'Аксесоари', // i18n-ignore: see titleKey
    titleEn: 'Accessories',
    items: [
      {
        labelKey: 'categories.accessories.keychains',
        name: 'Ключодържатели', // i18n-ignore: see labelKey
        nameEn: 'Keychains',
        href: '/продукти?category=keychains', // i18n-ignore: route slug
      },
      {
        labelKey: 'categories.accessories.magnets',
        name: 'Магнити', // i18n-ignore: see labelKey
        nameEn: 'Magnets',
        href: '/продукти?category=magnets', // i18n-ignore: route slug
      },
      {
        labelKey: 'categories.accessories.notebooks',
        name: 'Тефтери', // i18n-ignore: see labelKey
        nameEn: 'Notebooks',
        href: '/продукти?category=notebooks', // i18n-ignore: route slug
      },
      {
        labelKey: 'categories.accessories.jewelry',
        name: 'Бижута', // i18n-ignore: see labelKey
        nameEn: 'Jewelry',
        href: '/продукти?category=jewelry', // i18n-ignore: route slug
      },
    ],
  },
  {
    titleKey: 'categories.decoration.title',
    title: 'Декорация', // i18n-ignore: see titleKey
    titleEn: 'Decoration',
    items: [
      {
        labelKey: 'categories.decoration.candles',
        name: 'Соеви Свещи', // i18n-ignore: see labelKey
        nameEn: 'Soy Candles',
        href: '/продукти?category=candles', // i18n-ignore: route slug
      },
      {
        labelKey: 'categories.decoration.porcelainCastings',
        name: 'Порцеланови Отливки', // i18n-ignore: see labelKey
        nameEn: 'Porcelain Castings',
        href: '/продукти?category=porcelain-castings', // i18n-ignore: route slug
      },
      {
        labelKey: 'categories.decoration.carStickers',
        name: 'Стикери за Кола', // i18n-ignore: see labelKey
        nameEn: 'Car Stickers',
        href: '/продукти?category=car-stickers', // i18n-ignore: route slug
      },
    ],
  },
];

export interface QuickLink {
  labelKey: string;
  /** @deprecated Use `labelKey` with i18n. */
  name: string;
  /** @deprecated Use `labelKey` with i18n. */
  nameEn: string;
  href: string;
  icon: string;
}

export const QUICK_LINKS: QuickLink[] = [
  {
    labelKey: 'quickLinks.bestSellers',
    name: 'Най-продавани', // i18n-ignore: see labelKey
    nameEn: 'Best Sellers',
    href: '/продукти?sort=popular', // i18n-ignore: route slug
    icon: '🔥',
  },
  {
    labelKey: 'quickLinks.newProducts',
    name: 'Нови продукти', // i18n-ignore: see labelKey
    nameEn: 'New Products',
    href: '/продукти?sort=newest', // i18n-ignore: route slug
    icon: '✨',
  },
];

export const MAIN_NAV: NavLink[] = [
  {
    labelKey: 'mainNav.home',
    name: 'Начало', // i18n-ignore: see labelKey
    nameEn: 'Home',
    href: '/',
  },
  {
    labelKey: 'mainNav.products',
    name: 'Продукти', // i18n-ignore: see labelKey
    nameEn: 'Products',
    href: '/продукти', // i18n-ignore: route slug
    megaMenu: MEGA_MENU_CATEGORIES,
  },
  {
    labelKey: 'mainNav.about',
    name: 'За Нас', // i18n-ignore: see labelKey
    nameEn: 'About',
    href: '/за-нас', // i18n-ignore: route slug
  },
  {
    labelKey: 'mainNav.contact',
    name: 'Контакти', // i18n-ignore: see labelKey
    nameEn: 'Contact',
    href: '/контакти', // i18n-ignore: route slug
  },
];

// Popular searches — surfaced inside the SearchModal as suggestion chips.
// Keep as plain BG strings (SearchModal renders them only on the BG locale today).
export const POPULAR_SEARCHES: string[] = [
  'ключодържател', // i18n-ignore: search chip
  'чаша', // i18n-ignore: search chip
  'пъзел', // i18n-ignore: search chip
  'рамка', // i18n-ignore: search chip
  'свещ', // i18n-ignore: search chip
  'възглавница', // i18n-ignore: search chip
];

// ── Category Groups ─────────────────────────────────────────────────────────
export interface CategoryGroup {
  key: string;
  /** i18n key (in `common` namespace) for the group label. */
  labelKey: string;
  /** @deprecated Use `labelKey` with i18n. */
  label: string;
  /** @deprecated Use `labelKey` with i18n. */
  labelEn: string;
  emoji: string;
  slugs: string[]; // maps to Product.category values
}

export const CATEGORY_GROUPS: CategoryGroup[] = [
  {
    key: 'all',
    labelKey: 'categoryGroups.all',
    label: 'Всички', // i18n-ignore: see labelKey
    labelEn: 'All',
    emoji: '🎯',
    slugs: [],
  },
  {
    key: 'photo',
    labelKey: 'categoryGroups.photo',
    label: 'Фото', // i18n-ignore: see labelKey
    labelEn: 'Photo',
    emoji: '📷',
    slugs: ['photo-crystals', 'photo-frames', 'photo-stones', 'clocks'],
  },
  {
    key: 'gifts',
    labelKey: 'categoryGroups.gifts',
    label: 'Подаръци', // i18n-ignore: see labelKey
    labelEn: 'Gifts',
    emoji: '🎁',
    slugs: [
      'keychains',
      'mugs',
      'bottles',
      'puzzles',
      'magnets',
      'notebooks',
      'pillows',
      'tshirts',
    ],
  },
  {
    key: 'print',
    labelKey: 'categoryGroups.print',
    label: 'Принт & Стикери', // i18n-ignore: see labelKey
    labelEn: 'Print & Stickers',
    emoji: '🖨',
    slugs: ['stickers', 'perforated-vinyl', 'pvc-folio', 'car-stickers'],
  },
  {
    key: 'decor',
    labelKey: 'categoryGroups.decor',
    label: 'Декорация', // i18n-ignore: see labelKey
    labelEn: 'Decoration',
    emoji: '🕯',
    slugs: ['candles', 'ceramic', 'porcelain-castings'],
  },
];

// ── Sort Options ─────────────────────────────────────────────────────────────
export interface SortOption {
  value: string;
  /** i18n key (in `common` namespace) for the option label. */
  labelKey: string;
  /** @deprecated Use `labelKey` with i18n. */
  label: string;
  /** @deprecated Use `labelKey` with i18n. */
  labelEn: string;
}

export const SORT_OPTIONS: SortOption[] = [
  {
    value: 'popular',
    labelKey: 'sortOptions.popular',
    label: 'Популярни', // i18n-ignore: see labelKey
    labelEn: 'Popular',
  },
  {
    value: 'newest',
    labelKey: 'sortOptions.newest',
    label: 'Нови първо', // i18n-ignore: see labelKey
    labelEn: 'Newest first',
  },
  {
    value: 'price-asc',
    labelKey: 'sortOptions.priceAsc',
    label: 'Цена: ниска → висока', // i18n-ignore: see labelKey
    labelEn: 'Price: low → high',
  },
  {
    value: 'price-desc',
    labelKey: 'sortOptions.priceDesc',
    label: 'Цена: висока → ниска', // i18n-ignore: see labelKey
    labelEn: 'Price: high → low',
  },
  {
    value: 'featured',
    labelKey: 'sortOptions.featured',
    label: 'Препоръчани', // i18n-ignore: see labelKey
    labelEn: 'Featured',
  },
];
